
export default function ContactInfo() {
  return (
    <div className="space-y-8">
      <div>
        <span className="inline-block text-emerald-700 font-bold text-xs tracking-widest uppercase mb-3">
          Contact Information
        </span>
        <h2 className="text-3xl font-bold mb-4 tracking-wide">
          Let&apos;s Start a Conversation
        </h2>
        <p className="text-gray-600 leading-relaxed">
          Whether you&apos;re looking for a quote, have questions about our services, or want to discuss a specific challenge on your operation — reach out. We respond to every inquiry within one business day.
        </p>
      </div>

      {/* Contact Cards */}
      <div className="space-y-4">
        <div className="flex items-start gap-4 bg-white rounded-lg p-5 shadow-sm border border-gray-100">
          <div className="w-11 h-11 flex items-center justify-center bg-emerald-50 rounded-lg shrink-0">
            <i className="ri-phone-line text-xl text-emerald-700"></i>
          </div>
          <div>
            <h3 className="font-bold text-gray-900 mb-1">Phone</h3>
            <a
              href="tel:+17179131780"
              className="text-emerald-700 font-medium hover:text-emerald-800 transition-colors cursor-pointer"
            >
              (717) 913-1780
            </a>
            <p className="text-sm text-gray-500 mt-0.5">Mon–Fri, 7 AM – 6 PM EST</p>
          </div>
        </div>

        <div className="flex items-start gap-4 bg-white rounded-lg p-5 shadow-sm border border-gray-100">
          <div className="w-11 h-11 flex items-center justify-center bg-emerald-50 rounded-lg shrink-0">
            <i className="ri-mail-line text-xl text-emerald-700"></i>
          </div>
          <div>
            <h3 className="font-bold text-gray-900 mb-1">Email</h3>
            <a
              href="mailto:info@greenfieldpartners.com"
              className="text-emerald-700 font-medium hover:text-emerald-800 transition-colors cursor-pointer"
            >
              info@greenfieldpartners.com
            </a>
            <p className="text-sm text-gray-500 mt-0.5">We respond within 24 hours</p>
          </div>
        </div>

        <div className="flex items-start gap-4 bg-white rounded-lg p-5 shadow-sm border border-gray-100">
          <div className="w-11 h-11 flex items-center justify-center bg-emerald-50 rounded-lg shrink-0">
            <i className="ri-map-pin-line text-xl text-emerald-700"></i>
          </div>
          <div>
            <h3 className="font-bold text-gray-900 mb-1">Service Area</h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              Mid-Atlantic Region — Pennsylvania, Maryland, Delaware, Virginia, West Virginia
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4 bg-white rounded-lg p-5 shadow-sm border border-gray-100">
          <div className="w-11 h-11 flex items-center justify-center bg-emerald-50 rounded-lg shrink-0">
            <i className="ri-time-line text-xl text-emerald-700"></i>
          </div>
          <div>
            <h3 className="font-bold text-gray-900 mb-1">Response Time</h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              Standard inquiries: within 24 hours<br />
              Urgent spray requests: same-day callback
            </p>
          </div>
        </div>
      </div>

      {/* Social Links */}
      <div>
        <h3 className="font-bold text-gray-900 mb-3 text-sm">Follow Us</h3>
        <div className="flex gap-3">
          <a
            href="#"
            rel="nofollow"
            className="w-10 h-10 flex items-center justify-center bg-white border border-gray-200 rounded-lg text-gray-500 hover:text-emerald-700 hover:border-emerald-200 transition-colors cursor-pointer"
            aria-label="Facebook"
          >
            <i className="ri-facebook-fill text-lg"></i>
          </a>
          <a
            href="#"
            rel="nofollow"
            className="w-10 h-10 flex items-center justify-center bg-white border border-gray-200 rounded-lg text-gray-500 hover:text-emerald-700 hover:border-emerald-200 transition-colors cursor-pointer"
            aria-label="Twitter"
          >
            <i className="ri-twitter-x-fill text-lg"></i>
          </a>
          <a
            href="#"
            rel="nofollow"
            className="w-10 h-10 flex items-center justify-center bg-white border border-gray-200 rounded-lg text-gray-500 hover:text-emerald-700 hover:border-emerald-200 transition-colors cursor-pointer"
            aria-label="LinkedIn"
          >
            <i className="ri-linkedin-fill text-lg"></i>
          </a>
          <a
            href="#"
            rel="nofollow"
            className="w-10 h-10 flex items-center justify-center bg-white border border-gray-200 rounded-lg text-gray-500 hover:text-emerald-700 hover:border-emerald-200 transition-colors cursor-pointer"
            aria-label="Instagram"
          >
            <i className="ri-instagram-fill text-lg"></i>
          </a>
        </div>
      </div>
    </div>
  );
}
